import { render, staticRenderFns } from "./product-searchbar.vue?vue&type=template&id=ddb2b51a&"
import script from "./product-searchbar.vue?vue&type=script&lang=js&"
export * from "./product-searchbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports